import React from 'react';
import { List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const adminMenuItems = [
    { text: "User Management", to: '/admin/usermanagement' },
    { text: "Contact Responses", to: '/admin/contactregistrylist' },
    { text: "Resource Moderation", to: '/admin/resourcemoderation' },
    { text: "View Logo Assets", to: '/admin/viewlogoassets' },
    { text: "View Product Pages", to: '/admin/viewproductpages' },
    { text: "Ticker Test", to: '/admin/tickertest' },
];

function AdminMenu({ isAdminOpen, onAdminClick, toggleMenu }) {
    return (
        <React.Fragment>
            <ListItemButton onClick={onAdminClick}>
                <ListItemText primary="Admin" />
                {isAdminOpen ? <ExpandMore /> : <ChevronRight />}
            </ListItemButton>
            <Collapse in={isAdminOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {adminMenuItems.map((item) => (
                        <ListItemButton key={item.text} component={RouterLink} to={item.to} sx={{ pl: 4 }} onClick={toggleMenu}>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
}

export default AdminMenu;